import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getImageByWidth } from 'api';
import { useGlobalContext } from 'globalContext';
import ResizeDetector from 'react-resize-detector';
import { Cover } from 'msp-components';
import Error404 from 'components/Error404';

const normalizeItemData = (items, imgWidth = 1500, itemsById = {}) => items.map(item => {
  let image;
  if (item.backgroundImage) {
    image = (getImageByWidth(item.backgroundImage.versions, imgWidth) || {}).url;
  } else {
    const targetItem = itemsById[item.linkTarget];
    image = targetItem && (getImageByWidth(targetItem.previewImages.posterFrame, imgWidth) || {}).url;
  }

  let videoSource;
  let videoSourceType;
  let videoAspectRatio;
  if (item.backgroundVideo) {
    const bgv = item.backgroundVideo;
    videoSource = bgv.source === 'file' ? bgv.versions[0].url : bgv.metadata.sourceUrl;
    videoSourceType = bgv.source === 'file' ? 'htmlVideo' : bgv.source;
    videoAspectRatio = bgv.width / bgv.height;
  }

  return {
    id: item.uid,
    linkTarget: item.linkTarget,
    label: item.label,
    title: item.name,
    description: item.description,
    image,
    videoSource,
    videoSourceType,
    videoAspectRatio,
  };
});

const CoverTitle = ({
  routeProps,
  name,
  shortDescription,
  layout,
  showName,
  showDescription,
  buttonText,
  backgroundImage,
  backgroundVideo,
  animationDelay,
  itemsPerPage,
  loopVideo,
  items,
}) => {
  const [containerWidth, setContainerWidth] = useState();
  const handleResize = width => setContainerWidth(width);

  const { match, history } = routeProps;
  const { titlePaths, itemsById } = useGlobalContext();

  const imgWidth = containerWidth ? containerWidth * 1.5 : 1500;
  const coverItems = useMemo(() => normalizeItemData(items, imgWidth, itemsById), [items, imgWidth, itemsById]);

  const handleItemSelect = id => {
    const targetId = (coverItems.find(item => item.id === id) || {}).linkTarget;
    if (titlePaths[targetId]) history.push(titlePaths[targetId]);
  };

  const image = backgroundImage && getImageByWidth(backgroundImage.versions, imgWidth).url;

  let videoSource;
  let videoSourceType;
  let videoAspectRatio;
  if (backgroundVideo) {
    const bgv = backgroundVideo;
    videoSource = bgv.source === 'file' ? bgv.versions[0].url : bgv.metadata.sourceUrl;
    videoSourceType = bgv.source === 'file' ? 'htmlVideo' : bgv.source;
    videoAspectRatio = bgv.width / bgv.height;
  }

  if (!match.isExact) return <Error404 />;

  return (
    <>
      <ResizeDetector
        handleWidth
        onResize={handleResize}
        refreshMode="debounce"
        refreshRate={500}
      />
      <Cover
        layout={layout}
        title={showName ? name : ''}
        description={showDescription ? shortDescription : ''}
        image={image}
        buttonText={buttonText}
        videoSource={videoSource}
        videoSourceType={videoSourceType}
        videoAspectRatio={videoAspectRatio}
        animationDelay={animationDelay}
        itemsPerPage={itemsPerPage}
        loopVideo={loopVideo}
        items={coverItems}
        onSelectItem={handleItemSelect}
      />
    </>
  );
};

CoverTitle.propTypes = {
  routeProps: PropTypes.object,
  name: PropTypes.string,
  shortDescription: PropTypes.string,
  layout: PropTypes.string,
  showName: PropTypes.bool,
  showDescription: PropTypes.bool,
  buttonText: PropTypes.string,
  backgroundImage: PropTypes.object,
  backgroundVideo: PropTypes.object,
  animationDelay: PropTypes.number,
  itemsPerPage: PropTypes.number,
  loopVideo: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object),
};

export default CoverTitle;
